<div id="curtain" class="curtain">
    <div id="curtain-spinner" class="curtain-spinner"></div>
</div>
<router-outlet></router-outlet>
